import React, { createContext, useCallback, useState } from 'react'
import CreateAssessments from './CreateAssessments'
import { initialPage, initialPageSize } from 'keys/pagination'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { getTestTakers2Fetch } from 'store/middlewares/testTakers.crud'
import { affiliationGroups } from 'keys'
import { getCurrentSchoolYear, getCurrentSemester } from 'utils/general'
import { getSchoolStructureFetch, getLearningGroupStructureFetch } from 'store/middlewares/affiliation.crud'
import { useSelector } from 'react-redux'
import { isBoolean } from 'lodash'
import qc from 'keys/queryClient'

// יצירת ה-Context בראש הקובץ
export const CreateAssessmentsContext = createContext();

const CreateAssessmentsPage = (props) => {
    const { headerFilters } = useSelector(state => state.header)

    // create assessments
    const [preventDuplicateBatteries, setPreventDuplicateBatteries] = useState(true)
    const [selectedAssessmentDefs, setSelectedAssessmentDefs] = useState([])
    // select test takers
    const [page, setPage] = useState(initialPage)
    const [pageSize, setPageSize] = useState(initialPageSize)
    const [sorting, setSorting] = useState([])
    const [searchVal, setSearchVal] = useState("")
    const [gradeOpen, setGradeOpen] = useState(null)
    const [currentTab, setCurrentTab] = useState(0)
    const [learningGroupOpen, setLearningGroupOpen] = useState(null)
    const [testTakersSelection, setTestTakersSelection] = useState(null)

    const [year, setYear] = useState(getCurrentSchoolYear())
    const [semester, setSemester] = useState(getCurrentSemester())

    const [assessmentFilters, setAssessmentFilters] = useState({
        category: null,
        battery: null
    })

    const resetSelection = useCallback(() => {
        setGradeOpen(null)
        setLearningGroupOpen(null)
        setTestTakersSelection(null)
    }, [])

    const isSchoolsGroup = headerFilters.affiliation?.group_name == affiliationGroups.schools
    const learningUnit = headerFilters.school_class?.id || headerFilters.learning_group?.id
    const hasLearningUnit = !!learningUnit

    const schoolStructureOptions = queryOptions({
        queryKey: [qc.affiliationGrades, "create-assessments", headerFilters, year],
        queryFn: async () => {
            const { data } = await getSchoolStructureFetch(headerFilters, headerFilters.affiliation.id, year)
            return data
        },
        enabled: !!headerFilters.affiliation && isSchoolsGroup && !hasLearningUnit
    })
    const learningGroupStructureOptions = queryOptions({
        queryKey: [qc.learningGroups, headerFilters.affiliation?.id, headerFilters.learning_group?.id, headerFilters.home_affiliation, headerFilters.home_grade, "create-assessments", year],
        queryFn: async () => {
            const { data } = await getLearningGroupStructureFetch(headerFilters, headerFilters.affiliation.id, year)
            return data
        },
        enabled: !!headerFilters.affiliation && !isSchoolsGroup && !hasLearningUnit
    })
    const testTakersFlatList = useQuery({
        queryKey: [qc.testTakers, "flat", headerFilters.school_class, headerFilters.learning_group, headerFilters.test_taker, , headerFilters.home_affiliation, headerFilters.home_grade,],
        queryFn: async () => {
            const { data } = await getTestTakers2Fetch(headerFilters, headerFilters.affiliation.id)
            return data
        },
        enabled: hasLearningUnit
    })

    const school = useQuery(schoolStructureOptions)
    const learningGroups = useQuery(learningGroupStructureOptions)

    const commonState = {
        learningGroups, learningGroupStructureOptions,
        school, schoolStructureOptions,
        page, setPage,
        pageSize, setPageSize,
        gradeOpen, setGradeOpen,
        sorting, setSorting,
        searchVal, setSearchVal,
        currentTab, setCurrentTab,
        assessmentFilters, setAssessmentFilters,
        semester, setSemester,
        year, setYear,
        isSchoolsGroup,
        selectedTestTakers: testTakersSelection,
        setSelectedTestTakers: setTestTakersSelection,
        learningGroupOpen, setLearningGroupOpen,
        selectedAssessmentDefs, setSelectedAssessmentDefs,
        preventDuplicateBatteries, setPreventDuplicateBatteries,
        resetSelection,
        testTakersFlatList,
        hasLearningUnit, learningUnit,

        showBattery: isBoolean(props.showBattery) ? props.showBattery : true,// הדיפולט הוא להציג נתונים הקשורים לסוללה כמו פילטר
        customFilters: props.customFilters,
        isPractice: props.isPractice
    }

    return (
        <CreateAssessmentsContext.Provider value={commonState}>
            <CreateAssessments {...props} />
        </CreateAssessmentsContext.Provider>
    )
}

export default CreateAssessmentsPage